import axios from 'axios';

export const workflowOneErrorApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/workflow-one-error`,
    headers: {
        'Content-Type': 'application/json'
    }
})